module.exports = __webpack_public_path__ + "img/evidencesRequested_audit.5163eb08.svg";